module.exports = __webpack_public_path__ + "static/media/roadimg.01aad6b1.jpg";